export enum DmsTaxeSubType {
    vat = "vat",
    corporation_tax = "corporation_tax",
    business_tax = "business_tax",
    statement = "statement",
    income_tax = "income_tax",
    other_taxes = "other_taxes",
    tax_office = "FE",
}

export enum DmsDefaultSubType {
    all_subTypes = "all_subTypes",
    no_subTypes = "no_subTypes",
}

export enum SubTypeActions {
    createSubType = "createSubType",
    updateSubType = "updateSubType",
    deleteSubType = "deleteSubType",
}

export enum TableModeEnum {
    app = "app",
    modal = "modal",
}

export enum CashflowType {
    IN = "receipt",
    OUT = "spending",
}

export enum UploadFileStatus {
    NOT_UNIQ = "not uniq",
    READY_FOR_UPLOAD = "ready",
    PROGRESS = "progress",
    DONE = "done",
    ERROR = "error",
    ALREADY_UPLOADED = "alreadyUploaded",
    DECLINE = "decline",
}
